var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.732 7.212-4.086 4.104H21v1.386H5.664l4.086 4.086-.99.972L3 12l5.76-5.76.972.972Z",
    fill: "#000"
  })));
};
export { SvgBack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjczMiA3LjIxMjIzTDUuNjQ2IDExLjMxNjJIMjFWMTIuNzAyMkg1LjY2NEw5Ljc1IDE2Ljc4ODJMOC43NiAxNy43NjAyTDMgMTIuMDAwMkw4Ljc2IDYuMjQwMjNMOS43MzIgNy4yMTIyM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";